import React from 'react';
import hero from '../assets/hero.jpg';
const Careers = () => {
  const openings = [
    {
      title: "Senior Full Stack Developer",
      department: "Engineering",
      location: "San Francisco, CA",
      type: "Full-time",
      experience: "5+ years"
    },
    {
      title: "Product Designer",
      department: "Design", 
      location: "New York, NY",
      type: "Full-time",
      experience: "3+ years"
    },
    {
      title: "DevOps Engineer",
      department: "Engineering",
      location: "Remote",
      type: "Full-time", 
      experience: "4+ years"
    },
    {
      title: "Project Manager",
      department: "Operations",
      location: "Chicago, IL",
      type: "Full-time",
      experience: "5+ years"
    }
  ];

  const benefits = [
    "Competitive salary and equity",
    "Comprehensive health insurance",
    "Flexible work arrangements",
    "Professional development budget",
    "Unlimited PTO",
    "401(k) matching",
    "Latest equipment and tools",
    "Collaborative work environment"
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(rgba(218, 212, 212, 0.7), rgba(19, 1, 66, 0.8)), url(${hero})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 fade-in animate-fade-in-up">
            Join <span className="text-navy-blue">Our Team</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto fade-in animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            Build your career with innovative technology and amazing people
          </p>
        </div>
      </section>

      {/* Why Join Us */}
      <section className="py-20 relative">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16 fade-in">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              Why <span className="text-navy-blue">Tanvox</span>
            </h2>
            <p className="text-xl text-black max-w-3xl mx-auto">
              We're more than just a company – we're a community of innovators, creators, and problem-solvers
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-lg card-hover fade-in">
              <h3 className="text-2xl font-bold mb-4 text-dark-red">Innovation Culture</h3>
              <p className="text-black leading-relaxed">
                Work on cutting-edge projects that push the boundaries of technology and make a real impact on businesses worldwide.
              </p>
            </div>
            <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-lg card-hover fade-in">
              <h3 className="text-2xl font-bold mb-4 text-navy-blue">Growth Opportunities</h3>
              <p className="text-black leading-relaxed">
                Continuous learning and development opportunities with clear career paths and mentorship from industry leaders.
              </p>
            </div>
            <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-lg card-hover fade-in">
              <h3 className="text-2xl font-bold mb-4 text-dark-red">Work-Life Balance</h3>
              <p className="text-black leading-relaxed">
                Flexible work arrangements, remote options, and a culture that values your personal time and well-being.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-20 relative">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16 fade-in">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              Benefits & <span className="text-navy-blue">Perks</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="flex items-center fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <svg className="w-6 h-6 text-dark-red mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="text-black">{benefit}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Open Positions */}
      <section className="py-20 relative">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16 fade-in">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              Open <span className="text-navy-blue">Positions</span>
            </h2>
            <p className="text-xl text-black max-w-3xl mx-auto">
              Find your next opportunity with us
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            {openings.map((job, index) => (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-xl p-6 shadow-lg mb-4 card-hover fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                  <div className="mb-4 md:mb-0">
                    <h3 className="text-xl font-bold text-dark-red mb-2">{job.title}</h3>
                    <div className="flex flex-wrap gap-4 text-sm text-black">
                      <span className="flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                        </svg>
                        {job.department}
                      </span>
                      <span className="flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                        </svg>
                        {job.location}
                      </span>
                      <span className="flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                        </svg>
                        {job.type}
                      </span>
                      <span className="flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                        </svg>
                        {job.experience}
                      </span>
                    </div>
                  </div>
                  <button className="bg-gradient-to-r from-dark-red to-navy-blue text-white px-6 py-2 rounded-lg hover:shadow-lg transition-all duration-300 font-semibold">
                    Apply Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Culture */}
      <section className="py-20 relative">
        <div className="container mx-auto px-6">
          <div className="text-center max-w-4xl mx-auto fade-in">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Our <span className="text-navy-blue">Culture</span>
            </h2>
            <p className="text-xl text-black mb-8 leading-relaxed">
              At Tanvox Technologies, we foster a culture of collaboration, innovation, and continuous learning. We believe in empowering our team members to take ownership of their work and make meaningful contributions to exciting projects that shape the future of technology.
            </p>
            <p className="text-xl text-black mb-8 leading-relaxed">
              Join us and be part of a team that values creativity, diversity, and pursuit of excellence in everything we do.
            </p>
            <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-lg">
              <p className="text-2xl font-bold text-dark-red mb-4">Ready to join us?</p>
              <p className="text-black mb-6">
                Send your resume to careers@tanvoxttech.com and tell us why you'd be a great fit for our team.
              </p>
              <button className="bg-gradient-to-r from-dark-red to-navy-blue text-white px-8 py-3 rounded-lg hover:shadow-lg transition-all duration-300 font-semibold">
                Learn More About Working Here
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Careers;
